// extracted by mini-css-extract-plugin
export var card = "_67-0";
export var expandedCard = "_67-2";
export var paginated = "_67-1";